import { Component } from "react";

import ColoredMarker from "./ColoredMarker";
export interface NewDPEProps {
  params: {
    dpe: string;
    ges?: string;
    active?: boolean;
  };
  className?: string;
}

class NewDPE extends Component<NewDPEProps> {
  giveMeADpeColor(letter: string) {
    switch (letter) {
      case "A":
        return "#009D69";
      case "B":
        return "#00B34A";
      case "C":
        return "#41BD70";
      case "D":
        return "#FDE800";
      case "E":
        return "#FFB400";
      case "F":
        return "#FF7D29";
      case "G":
        return "#FF0000";

      default:
        return "#000000";
    }
  }

  render() {
    return (
      <>
        {/* <HoverPopper
                    poppingElement={
                        <Typography sx={{ display: "flex", flexDirection: "column", fontWeight: '500', fontSize: '12px' }}>
                            <Typography>Diagnostic de performance<br />énergétique (DPE)</Typography>
                            <Gauge value={this.props.params.dpe} mode="DPE" mini={true} />
                            <Typography>
                                Consommation <Typography component={'span'} sx={{ fontWeight: '300', fontSize: '11px' }}>(énergie primaire)<br />XXX kWh/m².an</Typography>
                            </Typography>
                            <hr style={{ borderTop: '1px solid black', opacity: '100%', margin: '10px 0' }} />
                            <Typography>Indice d'émission de gaz à<br /> effet de serre (GES)</Typography>
                            <Gauge value={this.props.params.ges} mode="GES" mini={true} />
                            <Typography>
                                Émissions : <Typography component={'span'} sx={{ fontWeight: '300', fontSize: '11px' }}>XXX kg CO₂/m².an</Typography>
                            </Typography>
                        </Typography>
                    }
                    spot='center'
                >
            </HoverPopper> */}
        <ColoredMarker
          className={this.props.className}
          color={this.giveMeADpeColor(this.props.params.dpe)}
          active={this.props.params.active}
        >
          {this.props.params.dpe}
        </ColoredMarker>
      </>
    );
  }
}
export default NewDPE;
